module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_doctor-aae83c6066a52f0992c7c9582d9859b9.svg";